import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import './assets/global.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import 'animate.css';
import VueAnimateOnScroll from 'vue3-animate-onscroll';

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);

app.use(VueAnimateOnScroll)

createApp(App).use(store).
use(router).use(vuetify).
mount('#app')
